/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_PreviewInputs */

const cs_templates_branding_preview = /** @type {(inputs: Templates_Branding_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled PDF v pořádku`)
};

const en_templates_branding_preview = /** @type {(inputs: Templates_Branding_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview PDF OK`)
};

/**
* | output |
* | --- |
* | "Preview PDF OK" |
*
* @param {Templates_Branding_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_preview = /** @type {((inputs?: Templates_Branding_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_preview(inputs)
	return cs_templates_branding_preview(inputs)
});